import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../lib/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" className="relative bg-[#1a1410] py-24 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <Overline>About Us</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
                Helping Individuals, Entrepreneurs &amp; Investors Build{" "}
                <span className="text-gold-foil">Financial Freedom</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-base sm:text-lg font-light leading-relaxed text-zinc-300">
                B. Thornton Capital &amp; Asset Group is a full-service financial
                consulting firm dedicated to helping clients recover assets,
                establish strong business foundations, improve credit profiles,
                and acquire wealth-building real estate opportunities.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 border-l-2 border-amber-500/60 pl-6">
                <p className="text-xs uppercase tracking-[0.2em] text-amber-500 mb-3">
                  Our Mission
                </p>
                <p className="font-serif italic text-xl sm:text-2xl text-zinc-100 leading-snug">
                  To provide professional financial solutions that create
                  generational wealth while delivering exceptional service built
                  on integrity, transparency, and results.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-base font-light leading-relaxed text-zinc-400">
                Whether you're starting your first business or expanding an
                existing portfolio, our team is committed to helping you move
                forward with confidence.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden aspect-[4/5] max-h-[620px]">
                <motion.img
                  style={{ y: imgY, scale: 1.15 }}
                  src={IMAGES.about}
                  alt="Financial consulting"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" />
                <div className="absolute inset-0 ring-1 ring-inset ring-amber-500/20" />
                <div className="absolute bottom-6 left-6 right-6">
                  <p className="font-serif text-2xl text-white">
                    Wealth isn't built by chance
                  </p>
                  <p className="text-amber-400 text-sm mt-1 tracking-wide">
                    It's built through opportunity, education, and action.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
